export class OrderSourceModel {

    clientIP: string;
    clientType: string;

    constructor() {
        this.clientIP = undefined;
        this.clientType = undefined;
    }
}
